import { useMemo } from "react";
import { PortalContent } from "../../enduser/components/PortalContent";
import { useVisiblePages } from "../../enduser/hooks/useVisiblePages";
import type { PortalSchema, Page } from "../../shared/schema";

interface PreviewPortalContentProps {
  schema: PortalSchema;
  currentPage: Page | null;
  onNavigate: (pageId: string) => void;
  onLogout: () => void;
  logoURL?: string;
  organizationName?: string;
  showSidebar: boolean;
  emptyMessage: string;
}

export const PreviewPortalContent: React.FC<PreviewPortalContentProps> = ({
  schema,
  currentPage,
  onNavigate,
  onLogout,
  logoURL,
  organizationName,
  showSidebar,
  emptyMessage,
}) => {
  const { visiblePages, isLoading: pagesLoading } = useVisiblePages(schema.pages);

  // Fall back to first visible page if current page is hidden (after visibility loads)
  const effectiveCurrentPage = useMemo(() => {
    if (pagesLoading || !currentPage) return currentPage;
    const isCurrentVisible = visiblePages.some((p) => p.id === currentPage.id);
    if (!isCurrentVisible) return visiblePages[0] ?? currentPage;
    return currentPage;
  }, [pagesLoading, currentPage, visiblePages]);

  return (
    <PortalContent
      schema={schema}
      visiblePages={visiblePages}
      currentPage={effectiveCurrentPage}
      onNavigate={onNavigate}
      onLogout={onLogout}
      logoURL={logoURL}
      organizationName={organizationName}
      showSidebar={showSidebar}
      emptyMessage={emptyMessage}
    />
  );
};
